import { Grid2 } from "@mui/material";
import React from "react";
import FormTextField from "../../../../component/form/FormTextField";
import VisitingHours from "../components/VisitingHours";

export default function ProofessionalDetails({ control, setValue }) {
  return (
    <>
      <Grid2 size={{ xs: 12, lg: 6 }}>
        <FormTextField
          placeholder="Speciality"
          label="Speciality"
          fieldname="speciality"
          control={control}
          required
          onlyText
        />
      </Grid2>
      <Grid2 size={{ xs: 12, lg: 6 }}>
        <FormTextField
          placeholder="Enter fee in PKR"
          label="Consultation Fee"
          fieldname="consultationFee"
          control={control}
          required
          type="number"
        />
      </Grid2>
      <Grid2 size={{ xs: 12 }}>
        <VisitingHours control={control} setValue={setValue} />
      </Grid2>
    </>
  );
}
